/**
 * A utility function to mark highlights of two strings
 * @param source - is the string that we are matching against.
 * @param target - is the string that we are matching with.
 * @returns {null|{sourceHighlights: {start: number, end: number}, targetHighlights: {start: number, end: number}}} -
 * returns start and end indexes of matching strings if not it returns null
 */
export const markHighlights = (source, target) => {
  if (source && target) {
    const sourceString = source.toLowerCase()
    const targetString = target.toLowerCase()
    // search for target string inside the source - case insensitive
    if (sourceString.includes(targetString)) {
      // escape special characters in the string
      const str = new RegExp(targetString.replace(/(?=\W)/g, '\\'))
      const match = str.exec(sourceString)
      if (match) {
        const start = match.index
        const end = start + match[0].length - 1

        return {
          sourceHighlights: {
            start,
            end,
          },
          targetHighlights: {
            start: 0, // always 0 since we are matching the whole string against the source
            end: target.length - 1,
          },
        }
      }
      return null
    }
  }
  return null
}
